import script from "./ReadinessBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadinessBanner.vue?vue&type=script&setup=true&lang=js"

import "./ReadinessBanner.vue?vue&type=style&index=0&id=4bf89e7c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf89e7c"]])

export default __exports__